import actions from '../action/pay'
import CONSTANT from '../constant/pay'

const payStatus = -2
const confirmDeliveryStatus = null;
export default {
  actions,
  state: {
    payStatus,
  },
  mutations: {
    [CONSTANT.PAY_GET_STATUS_SUCCESS] (state, data) {
      return state.payStatus = 0
    },
    [CONSTANT.PAY_GET_STATUS_ERROR] (state, e) {
      return state.payStatus = -2
    },
  },
  getters: {
    [CONSTANT.PAY_GETTER_STATUS](state) {
      return state.payStatus
    }
  }
}
